import React, { FunctionComponent } from 'react';
import Card from '@Components/Card/Card';

const ShowOnMap: FunctionComponent<types.cards.IMapCardProps['params']> = ({ coordinates }) => {
	return <Card<types.cards.IMapCardProps> card="showOnMap" params={{ coordinates }} withoutContainerPadding />;
};

export default ShowOnMap;
